import { api, type Fetch, type ResultOf } from '$lib/erar/api';
import { get, writable, type Writable } from 'svelte/store';

type StaticAllResult = ResultOf<'GET /static/all'>;

export const erStatic: Writable<StaticAllResult | undefined> = writable(undefined);

export async function initStaticData(fetch: Fetch) {
  const status = await api('GET /status', {
    fetch,
  });
  if (status.version !== get(erStatic)?.version) {
    await fetchStaticAndCache(fetch);
  }
}

export async function fetchStaticAndCache(fetch: Fetch) {
  const result = await api('GET /static/all', {
    fetch,
    headers: {
      'cache-control': 'max-age=864000',
    },
  });
  erStatic.set(result);
}
